import React, { Component } from 'react';
import { Upload } from 'antd';
import { v4 as uuidv4 } from 'uuid';

import PropTypes from 'prop-types';
import { ref } from 'firebase/storage';
import resizeAndCropImage from '../../../firebase/util/image';
import { MAX_HEIGHT, MAX_WIDTH } from '../../../firebase/Constants';

const generateRandomFilename = () => uuidv4();

function extractExtension(filename) {
  const ext = /(?:\.([^.]+))?$/.exec(filename);
  if (ext != null && ext[0] != null) {
    return ext[0];
  }
  return '';
}

class AvatarUploader extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleChange = ({ file }) => {

    if (file.status === 'done') {
      const { storageFolder } = this.props;
      ref(storageFolder)
        .child(file.name)
        .getDownloadURL()
        .then(url => {

          const { onAvatarUpdate } = this.props;
          onAvatarUpdate(url);
        });
    }
  };

  // eslint-disable-next-line no-unused-vars
  startUpload = ({ onError, onSuccess, file }) => {

    const {
      onUploadStart,
      onProgress,
      // eslint-disable-next-line no-unused-vars
      onUploadError,
      // eslint-disable-next-line no-unused-vars
      onUploadSuccess,
      storageRef,
      metadata,
      randomizeFilename,
      filename,
    } = this.props;

    let filenameToUse;
    if (filename) {
      filenameToUse =
        typeof filename === 'function' ? filename(file) : filename;
    } else {
      filenameToUse = randomizeFilename ? generateRandomFilename() : file.name;
    }

    // Ensure there is an extension in the filename
    if (!extractExtension(filenameToUse)) {
      filenameToUse += extractExtension(file.name);
    }

    Promise.resolve()
      .then(() => {
        return resizeAndCropImage(file, MAX_WIDTH, MAX_HEIGHT);
      })
      .then(newFile => {
        const meta = {
          ...metadata,
          cacheControl: 'public, max-age=86400',
        };
        const task = storageRef.child(filenameToUse).put(newFile, meta);

        if (onUploadStart) {
          onUploadStart(newFile, task);
        }

        task.on(
          'state_changed',
          snapshot =>
            onProgress &&
            onProgress(
              Math.round(
                (100 * snapshot.bytesTransferred) / snapshot.totalBytes,
              ),
              task,
            ),
          error =>
            this.handleUploadError && this.handleUploadError(error, task),
          () => {

            onSuccess(null, task);
            return (
              this.handleUploadSuccess &&
              this.handleUploadSuccess(task.snapshot.metadata.name, task)
            );
          },
        );
        // this.uploadTasks.push(task);
      });
  };

  render() {
    const { children } = this.props;
    return (
      <div>
        <Upload
          onChange={this.handleChange}
          customRequest={this.startUpload}
          showUploadList={false}
        >
          {children}
        </Upload>
      </div>
    );
  }
}

AvatarUploader.propTypes = {
  storageRef: PropTypes.object,
  onUploadStart: PropTypes.func,
  onProgress: PropTypes.func,
  onUploadSuccess: PropTypes.func,
  onUploadError: PropTypes.func,
  filename: PropTypes.string,
  metadata: PropTypes.object,
  randomizeFilename: PropTypes.bool,
  children: PropTypes.object,
  storageFolder: PropTypes.object,
  onAvatarUpdate: PropTypes.func,
};

export default AvatarUploader;
